module.exports = __webpack_public_path__ + "static/media/spinner.8dbf5fa7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/spinner.svg
// module id = 871
// module chunks = 21